export function sendAnalytics(type, action, label) {
  let data = {
    analytics: { type, action, label },
  };
  console.log('should send Analytics:', data);
  if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
    console.log('analytics sent!');
  } else {
    console.log('window.ReactNativeWebView not available');
  }
}
